
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, useQuery } from 'react-query';
import { fetchResellers } from './fetch-resellers';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Props` type.
 */

type Props<P> = QueryObserverBaseResult<P, unknown>;

/**
 * `Options` type.
 */

type Options<P> = {
  filterParams?: any,
  initialData?: P | null
};

/**
 * Action type.
 */

const actionType = ({ locale }): string => {
  return `${locale}-resellers`;
};

/**
 * `useResellers` hook.
 */

function useResellers<P>(options?: Options<P>): Props<P> {
  const { locale } = useRouter();
  const variables = useMemo(() => ({
    locale,
    params: options?.filterParams
  }), [locale, options.filterParams]);

  const result = useQuery([actionType({ locale }), variables], () => {
    return fetchResellers(variables);
  }, {
    initialData: options?.initialData
  });

  return result;
}

/**
 * Export `useResellers` hook.
 */

export default useResellers;
